<div class="terms-section">
  <p class="terms-title">MobilPant er kun for dem som er eller blir kunder hos ice.</p>
  <p>
    Det vil si at kunden enten må ha et abonnement hos ice fra før av, eller at de bestiller et abonnement i forbindelse
    med at MobilPanten løses inn.
  </p>
</div>
<div class="terms-section">
  <p class="terms-title">Andre betingelser</p>
  <ul>
    <li>Maks fire MobilPant-forespørsler kan være aktive samtidig.</li>
    @if (!isRetailPayment()) {
      <li>Sluttsummen i kjøpet må være høyere enn panteverdien.</li>
    }
  </ul>
</div>
